import { injectIntl } from 'react-intl';
import {
    Dialog,
    ScreenMessagePanelContainer,
    TextArea,
    formatMessage,
    ButtonLight,
    ButtonStandard,
    FormFieldContainer,
    Label,
} from 'cw-ui-core';
import css from './GenerateTokenDialog.scss';
import Locale from 'src/i18n';
import React, { useEffect } from 'react';

export const GENERATE_TOKEN_DIALOG = 'GENERATE_TOKEN_DIALOG';

const GenerateTokenDialog = props => {
    const { onDidMount } = props;
    useEffect(() => {
        onDidMount();
    }, [onDidMount]);

    const dialogButtons = [
        <ButtonLight
            key="cancel"
            automationName="cancel"
            className={css.cancelButton}
            value={formatMessage(Locale.cancel)}
            onClick={props.onCancelButtonClick}
        />,
        <ButtonStandard
            key="copy"
            automationName="copy"
            className={css.copyButton}
            value={formatMessage(Locale.copy)}
            onClick={props.onCopyButtonClick}
        />,
    ];

    return (
        <Dialog
            dialogId={GENERATE_TOKEN_DIALOG}
            header={formatMessage(Locale.registrationToken)}
            buttons={dialogButtons}>
            <Label className={css.tokenValid} value={formatMessage(Locale.tokenOnlyValidFor)} />
            <div className={css.wrap}>
                <ScreenMessagePanelContainer className={css.screenMessage} screenKey={GENERATE_TOKEN_DIALOG} />
                <FormFieldContainer
                    path={['tokenDetails', 'token']}
                    label={formatMessage(Locale.token)}
                    screenKey={GENERATE_TOKEN_DIALOG}
                    className={css.inputBox}>
                    <TextArea value={props.token} />
                </FormFieldContainer>
            </div>
        </Dialog>
    );
};

export default injectIntl(GenerateTokenDialog);
